import { RootState } from '../store';
import { initialState } from './snackBarSlice';

export const selectSnackBar = (state: RootState) =>
  state.snackBar || initialState;

export const selectIsOpen = (state: RootState) => state.snackBar?.isOpen;
